import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateClinicUser } from '@/services/admin/clinicUsers';
import type { UpdateClinicUserPayload } from '@/services/admin/clinicUsers';

/**
 * Mutation hook to update a clinic user (admin portal).
 * Invalidates clinic detail and clinic user queries on success.
 */
export const useUpdateClinicUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      siteType,
      id,
      data,
    }: {
      siteType: string;
      id: number;
      data: UpdateClinicUserPayload;
    }) => updateClinicUser(siteType, id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'clinic-users', variables.siteType, variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ['clinic-detail'] });
    },
  });
};
